/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PdfExportCheck,
    PdfExportCheckFromJSON,
    PdfExportCheckFromJSONTyped,
    PdfExportCheckToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface PdfExportCheckResponse
 */
export interface PdfExportCheckResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof PdfExportCheckResponse
     */
    msg: string;
    /**
     * 
     * @type {PdfExportCheck}
     * @memberof PdfExportCheckResponse
     */
    entry: PdfExportCheck;
}

export function PdfExportCheckResponseFromJSON(json: any): PdfExportCheckResponse {
    return PdfExportCheckResponseFromJSONTyped(json, false);
}

export function PdfExportCheckResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdfExportCheckResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': PdfExportCheckFromJSON(json['entry']),
    };
}

export function PdfExportCheckResponseToJSON(value?: PdfExportCheckResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': PdfExportCheckToJSON(value.entry),
    };
}


